/**
 * Detect when a response body is actually an HTML document (the SPA index.html
 * shell) served in place of the expected JSON.
 *
 * This happens when an API request falls through to the SPA fallback — a
 * misconfigured reverse proxy (`try_files … /index.html`), a stale deploy, a
 * dev-proxy gap, or a relative URL resolving under `/app`. Axios then fails to
 * JSON-parse the HTML and silently returns the raw string as `response.data`;
 * handing that to code that spreads/maps it throws the opaque
 * `TypeError: object is not iterable (cannot read property Symbol(Symbol.iterator))`.
 *
 * Anchored with `^\s*` so a legitimate JSON string value that merely *contains*
 * `<html>` somewhere in the middle is never misclassified.
 */
export function looksLikeHtml(data: unknown, contentType?: string): boolean {
  if (typeof contentType === 'string' && contentType.toLowerCase().includes('text/html')) {
    return true;
  }
  return typeof data === 'string' && /^\s*<(?:!doctype|html)\b/i.test(data);
}
